import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';

// ==============================|| LAZY LOADED PAGES ||============================== //

// Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/Default')));

// Customer Pages
const FindMyHome = Loadable(lazy(() => import('../pages/customer/find-my-home/LotSection')));
const FloorPlannerPage = Loadable(lazy(() => import('../pages/customer/find-my-home/FloorPlanner')));
const Documents = Loadable(lazy(() => import('../pages/customer/documents/index')));
const DocumentsPending = Loadable(lazy(() => import('../pages/customer/documents/pending')));

const Payments = Loadable(lazy(() => import('../pages/customer/payments')));
const PaymentsHistory = Loadable(lazy(() => import('../pages/customer/payments/history')));
const Walkthrough = Loadable(lazy(() => import('../pages/customer/schedule/walkthrough')));
const Meetings = Loadable(lazy(() => import('../pages/customer/schedule/meetings')));
const SubmitClaim = Loadable(lazy(() => import('../pages/customer/claims/SubmitClaim')));
const TrackClaim = Loadable(lazy(() => import('../pages/customer/claims/TrackClaim')));
const ProjectTracker = Loadable(lazy(() => import('../pages/customer/projectTracker/ProjectTracker')));
const AIAssistance = Loadable(lazy(() => import('../pages/customer/aiassitance/index')));

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'find-home',
      children: [
        {
          path: '',
          element: <FindMyHome />
        },
        {
          path: 'floor-planner',
          element: <FloorPlannerPage />
        }
      ]
    },
    {
      path: 'documents',
      children: [
        {
          path: '',
          element: <Documents />
        },
        {
          path: 'pending',
          element: <DocumentsPending />
        }
      ]
    },
    {
      path: 'payments',
      children: [
        {
          path: '',
          element: <Payments />
        },
        {
          path: 'history',
          element: <PaymentsHistory />
        }
      ]
    },
    {
      path: 'schedule',
      children: [
        {
          path: 'walkthrough',
          element: <Walkthrough />
        },
        {
          path: 'meetings',
          element: <Meetings />
        }
      ]
    },
    {
      path: 'claims',
      children: [
        {
          path: '',
          element: <SubmitClaim />
        },
        {
          path: 'track',
          element: <TrackClaim />
        }
      ]
    },
    {
      path: 'project-tracker',
      element: <ProjectTracker />
    },
    {
      path: 'ai-assistance',
      element: <AIAssistance />
    }
  ]
};


export default MainRoutes;
